module.exports = __webpack_public_path__ + "img/cap_preview.fd99bb94.jpg";